import React from 'react';

import { CurrencyIcon } from '@pkg/components';
import { type BaseCurrencyType } from '@pkg/types';
import { formatUsd } from '@pkg/utils';

import {
    CurrencyIconWrapper,
    NativePriceWrapper,
    NativeText,
    StyledNonEditablePrice,
    UsdText,
} from './NonEditablePrice.style';

export interface NonEditablePriceProps {
    usdPrice?: number;
    nativePrice?: number;
    nativeCurrency?: BaseCurrencyType;
}

export function NonEditablePrice({ usdPrice = 0, nativePrice = 0, nativeCurrency = 'usd' }: NonEditablePriceProps) {
    const nativeMarkup =
        nativePrice && nativeCurrency === 'usd' ? null : (
            <NativePriceWrapper>
                <CurrencyIconWrapper>
                    <CurrencyIcon currency={nativeCurrency} theme="glyph" />
                </CurrencyIconWrapper>

                <NativeText>{nativePrice}</NativeText>
            </NativePriceWrapper>
        );

    return (
        <StyledNonEditablePrice>
            <UsdText>{formatUsd(usdPrice, true)}</UsdText>
            {nativeMarkup}
        </StyledNonEditablePrice>
    );
}
